/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Patient/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Patient({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/PatientOptions/New/ReferralSource/Content/Content/Referrals/Referral/Source/Search/Preview/Details/Patient"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let referralPersonValueData = fromData.useDataFormat({ viewPath,
context: 'referral',
path: 'person',
format: fromFormat.patientName,
})
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let referralPersonGender0ValueData = fromData.useDataValue({ viewPath,
context: 'referral',
path: 'person.gender.0',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let referralPersonBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'referral',
path: 'person.birth_date',
format: fromFormat.age,
})
  return (<React.Fragment
>
<div
  data-testid="Patient.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Patient.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-124axH': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsBlack}
 whiteSpace="nowrap"
 data="referral.person"
 format="/Data/format.js patientName"
 text={referralPersonValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsBlack}
 text="•"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="referral.person.gender.0"
 text={referralPersonGender0ValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsBlack}
 text="•"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 whiteSpace="nowrap"
 data="referral.person.birth_date"
 format="/Data/format.js age"
 text={referralPersonBirthDateValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}